import { BaseEntity, getCachedStructureEntity } from ".";
import { IGet_corporations_corporation_id_orders_200_ok } from "../service/esiclient";
import { getCachedTypeEntity } from "./TypeEntityCache";
import moment from "moment";
import { getCachedStationEntity } from "./StationEntityCache";

export class CorporationOrderEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Corporation Order";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_corporations_corporation_id_orders_200_ok> = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      // - Id
      if (props.issued) {
        const issued = moment(props.issued);
        entity.properties["issued"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: issued.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (!props.is_buy_order) {
        entity.properties["is_buy_order"] = {
          type: Excel.CellValueType.boolean,
          basicValue: false,
        };
      }
      if (props.location_id) {
        const stationEntity = await getCachedStationEntity(props.location_id);
        if (stationEntity !== null) {
          entity.properties["location"] = await stationEntity.toJson(true);
          delete entity.properties["location_id"];
        } else {
          const structureEntity = await getCachedStructureEntity(props.location_id, this._character_id);
          if (structureEntity !== null) {
            entity.properties["location"] = await structureEntity.toJson(true);
            delete entity.properties["location_id"];
          }
        }
      }
      delete entity.properties["id"];
      const item = props.type_id ? await getCachedTypeEntity(props.type_id) : null;
      const name = item !== null ? item.props["name"] : "Unknown item";
      const numberOptions = { minimumFractionDigits: 2 };
      const priceVar = props.price?.toLocaleString("en-GB", numberOptions);
      // The display for now is "amount ISK (description)"", not a lot of informative strings in this property
      entity.text = name + " @ " + priceVar + " ISK (" + props.volume_remain + "/" + props.volume_total + ")";
      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: entity.text,
      };
    }
    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
